import { apiUrl } from '../utils/constants';
import { DELETE, GET, POST, PUT } from './api.service.wrapper';



export const GetVat = async (keyword = '', page = '', perPage = '', is_paginate = 1) => {
    let params = {};

    if (page) {
        params['page'] = page;
    }

    if (perPage) {
        params['per_page'] = perPage;
    }


    if (keyword) {
        params['key'] = keyword;
    }

    if(is_paginate === 1){
        params['paginate'] = is_paginate;

    }

    const response = await GET(apiUrl.settings, params);
    return response;
}

export const GetVatById = async (id) => {
    let params = {};
    let response = '';
    response = await GET(apiUrl.settings + '/' + id,params);
    return response;
}

export const CreateVat = async (data) => {
    const response = await POST(apiUrl.settings, data);
    return response;
}

export const UpdateVat = async (id, data) => {
    const response = await PUT(apiUrl.settings, id, data);
    return response;
}

export const DeleteVat = async (id) => {
    const response = await DELETE(apiUrl.settings, id);
    return response;
}
